import localforage from "localforage";
import { apiUrl, apiNewVersion, } from "../../config";

export default async function addBanner (
    banner
) {
    const formData = new FormData();
    for (const field in banner) {
        if (["image",].includes(field)) {
            if (banner[field] !== undefined) {
                formData.append(field, banner[field]);
            }
        } else {
            if (banner[field] !== undefined) {
                formData.append(field, JSON.stringify(banner[field]));
            }
        }
    }
    const token = await localforage.getItem("339vending.admin-token");
    const response = await fetch(
        `${ apiUrl }/${ apiNewVersion }/banner`,
        {
            "method": "POST",
            "headers": {
                "Accept": "application/json",
                "Authorization": `Bearer ${ token }`
            },
            "body": formData,
        }
    );

    if (response.ok) {
        const banner = await response.json();
        if (banner) {
            return banner;
        }
        throw "BANNER POST error";
    }

    if (response.status >= 400) {
        throw await response.text();
    }

    throw "Internal server error";
}
